import Head from "next/head";
import { FunctionComponent } from "react";

import { Tabpanel, Tabs } from "@/components";

const Stablecoin: FunctionComponent = () => (
  <>
    <Head>
      <title>BankX - Stablecoin</title>
    </Head>
    <h1 className="visually-hidden">Stablecoin</h1>
    <h3 className="column-3 column-span-9">
      The first <strong>silver-pegged</strong>, crypto-backed stablecoin that
      pays you interest where you never face liquidation.
    </h3>
    <Tabs className="column-3 column-span-9">
      <Tabpanel label="Problems">
        <ul>
          <li>
            <u>Terra Luna</u>, with <u>no collateral</u>, lost $60B as it{" "}
            <b>
              went to <em>zero</em>.
            </b>
          </li>
          <li>
            <u>Silicon Valley Bank</u>, holding collateral for USDC,{" "}
            <b>went bankrupt.</b>
          </li>
          <li>
            <u>USDC</u> has been estimated to earn{" "}
            <b>
              $1.6B a year&nbsp;using <em>your</em> money.
            </b>
          </li>
          <li>
            Centralized stablecoins, like <u>USDT</u>,{" "}
            <b>
              can be <em>shut down</em>.
            </b>
          </li>
          <li>
            Other collateral-backed stablecoins like DAI{" "}
            <b>
              can be <em>liquidated</em>.
            </b>
          </li>
          <li>
            <u>USD stablecoins</u> face{" "}
            <b>
              tremendous <em>loss</em> in purchasing power
            </b>{" "}
            from inflation.
          </li>
        </ul>
      </Tabpanel>
      <Tabpanel label="The Solution">
        <ul>
          <li>
            <u>Silver-Pegged</u> to <b>hedge against inflation.</b>
          </li>
          <li>
            <u>Crypto-Backed</u> so there is value you can{" "}
            <b>redeem anytime.</b>
          </li>
          <li>
            A <u>Blockchain-controlled collateral</u> system{" "}
            <b>only accessed by you.</b>
          </li>
          <li>
            Designed so the <u>collateral</u> backing it is{" "}
            <b>never liquidated.</b>
          </li>
          <li>
            <u>Fully decentralized</u> so it <b>cannot be shut down.</b>
          </li>
          <li>
            A <u>stablecoin</u> where{" "}
            <b>
              <em>you</em> earn the interest for minting it.
            </b>
          </li>
        </ul>
      </Tabpanel>
      <Tabpanel label="Currency Creator’s Manifesto">
        <p>
          Our world faces an urgent crisis of currency manipulation, theft and
          inflation. Under the current system, currency is controlled by and
          benefits elite families, governments and large banking institutions.
          <strong>
            We believe currencies should be minted by and benefit the
            individual, not the establishment.
          </strong>{" "}
          It is time to take back the control of and the freedom that money can
          provide.
        </p>
        <p>
          BankX is rebuilding the legacy banking system from the ground up by
          providing you with the capability to create currency and be in
          complete control of wealth creation with a concept we call
          &apos;Individual Created Digital Currency&apos; (ICDC). You own the
          collateral. You mint currency. You earn interest. You leverage without
          the risk of liquidation. You lock up your currency for even more
          returns. All of this is done with complete autonomy and
          decentralization.{" "}
          <strong>BankX has built a stablecoin for Individual Freedom</strong>.
        </p>
        <p>
          BankX is the antidote for the malevolent financial system bringing in
          a new future of freedom where you are in complete control with no
          middlemen, bank or central bank between you and your finances. This
          capability to create currency and be in complete control of wealth
          creation will be in the hands of every individual that uses BankX.
        </p>
        <p>
          By 2030, we will rid the world of the corrupt, tyrannical and
          incompetent banking system replacing it with a system where billions
          of people have complete freedom of their financial future. Everyone
          will be given ultimate freedom to use their assets to create currency,
          earn interest and multiply returns to accomplish their individual
          goals. The mission of BankX is to be the first to mint $1 trillion in
          stablecoin.
        </p>
        <p>
          We will bring about this transformation by attracting people that
          believe what we believe. We will partner with other blockchain
          protocols and build decentralized applications that drive even more
          usage. Finally, we will deploy a private network that is never
          connected to the Internet to communicate between counterparties, that
          allows for blockchain-to-blockchain interoperability and stores
          private keys and cryptocurrency wallets. Our ecosystem, network and
          platform has never been seen in the market and provides us with a long
          term sustainable competitive advantage.
        </p>
        <h6>We value individual freedom.</h6>
        <h6>We believe in financial autonomy.</h6>
        <h6>We are anti-establishment.</h6>
        <h6>We envision a future of self-empowerment.</h6>
      </Tabpanel>
    </Tabs>
  </>
);

export default Stablecoin;
